import { createUseStyles } from 'react-jss';
import { base } from '../../css/vars';

export default createUseStyles({
  insertCopyColors: {
    '& > *:not(:last-child)': {
      marginBottom: base(),
    },
  },
});
